export default __webpack_public_path__ + "static/media/group-kitty-card.a9df6e65.png";